import { render, staticRenderFns } from "./label-dropdown.vue?vue&type=template&id=e9296888&scoped=true&"
import script from "./label-dropdown.vue?vue&type=script&lang=ts&"
export * from "./label-dropdown.vue?vue&type=script&lang=ts&"
import style0 from "./label-dropdown.vue?vue&type=style&index=0&id=e9296888&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9296888",
  null
  
)

export default component.exports